<template>
  <div id="team_videos_list_outer" v-if="videoList != null && videoList.length > 0">
    <div v-if="teamVideoList != null && teamVideoList.length > 0" style="background-color: #aaa;width: 100%;height: 40px;line-height: 40px;font-weight: bold;">比赛集锦</div>
    <video-item-card
      v-for="(item, index) in teamVideoList"
      :key="'team_video_' + index"
      v-on:play="playVideo"
      v-bind:item="item"></video-item-card>
    <div v-if="personVideoList != null && personVideoList.length > 0" style="background-color: #aaa;width: 100%;height: 40px;line-height: 40px;font-weight: bold;margin-top: 30px;">个人集锦</div>

    <video-item-card
      v-for="(item, index) in personVideoList" :key="'person-video' + index"
      v-on:play="playVideo"
      v-bind:item="item" ></video-item-card>

    <video-play-dialog v-if="showVideoDialog"
                       v-bind:video-url="'https://obs.zheshi.tech/'+ currentItem.video_path"
                       v-on:close="videoDialogClosed"></video-play-dialog>
  </div>
</template>

<script>
  import VideoItemCard from "./VideoItemCard";
  import VideoPlayDialog from "../../components/common/VideoPlayDialog";
  import GameHttpManager from '../../js/outer-games-http-define';
export default {
  name: "TeamVideosList",
  components: {
    VideoItemCard,
    VideoPlayDialog,
  },
  computed: {
    id() {
      let id = this.$route.query.id;
      return id == undefined ? null : id;
    }
  },
  data() {
    return {
      showVideoDialog: false,
      currentItem: null,
      teamVideoList: null,

      personVideoList: null,
      videoList: null,
    }
  },
  mounted() {
    this.loadVideoData();
  },
  methods: {

    loadVideoData() {
      let id = this.id;
      let _this = this;
      GameHttpManager.getGameVideoListData(id, function (data) {
        let status = data.status;
        if (status == 'success') {
          _this.videoList = data.data;
          _this.dealWithDataLoadSuccess();
        }
      }, function (data) {
        _this.$toast('请求失败');
      });
    },
    dealWithDataLoadSuccess() {
      let videoList = this.videoList;
      if (videoList == null || videoList.length == 0) {
        return;
      }

      let teamVideoList = [];
      let personVideoList = [];

      for (let i = 0; i < videoList.length; i++) {
        let item = videoList[i];
        if (item.player_id == 0) {
          teamVideoList.push(item);
        } else {
          personVideoList.push(item);
        }
      }

      this.teamVideoList = teamVideoList;
      this.personVideoList = personVideoList;

    },

    playVideo(item) {
      this.currentItem = item;
      this.showVideoDialog = true;
    },
    videoDialogClosed() {
      this.showVideoDialog = false;
    }
  }
}
</script>

<style scoped>

  #team_videos_list_outer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/TeamVideosList.vue